import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class TopicsList extends Component {
  state = {
    topics: this.props.topics,
    topicsToDisplay: 10,
    isExpanded: false,
    isButtonDisplayed: true,
  };

  displayMoreTopics = () => {
    const { topics, topicsToDisplay } = this.state;
    const remainingTopics = topics.length - topicsToDisplay;

    if (remainingTopics >= 5) {
      this.setState({
        topicsToDisplay: topicsToDisplay + 5,
        isExpanded: true,
      });
    } else {
      this.setState({
        topicsToDisplay: topics.length,
        isExpanded: true,
        isButtonDisplayed: false,
      });
    }
  };

  render() {
    const { topics, topicsToDisplay, isButtonDisplayed } = this.state;

    const { style } = this.props;

    return (
      <>
        {topics.slice(0, topicsToDisplay).map((topic, index) => (
          <li className={style['feed-item']} key={topic.id}>
            <Link to={`/topic/${topic.name}`} className={style['feed-link']}>
              <span className={style['feed-icon']}>
                <img
                  src={topic.imgUrl}
                  alt={topic.name}
                  className={style['feed-img']}
                />
              </span>{' '}
              <span className={style['feed-name']}>{topic.name}</span>
            </Link>
          </li>
        ))}
        {isButtonDisplayed && (
          <button
            className={style['more-topics']}
            onClick={this.displayMoreTopics}
          >
            More topics
          </button>
        )}
      </>
    );
  }
}

TopicsList.defaultProps = {
  topics: [],
};

TopicsList.propTypes = {
  topics: PropTypes.array.isRequired,
  style: PropTypes.object.isRequired,
};

export default TopicsList;
